import type { TagPromotion } from '~~/types/integrations/tagManager/TagPromotion';

export const buildPromotionTags = ({
  viewPromotions,
  clickPromotions,
}: {
  viewPromotions?: TagPromotion[];
  clickPromotions?: TagPromotion[];
}) => ({
  ecommerce: {
    ...(viewPromotions?.length
      ? { promoView: { promotions: viewPromotions } }
      : {}),
    ...(clickPromotions?.length
      ? { promoClick: { promotions: clickPromotions } }
      : {}),
  },
});
